import React from 'react';
import colors from "../../utils/colors";
import { WarningFilled } from "../../icons";

import { createStyles } from "./styles";

var ValidationBlock = function ValidationBlock(props) {
  var value = props.value,validationMessage = props.validationMessage,_props$validationPass = props.validationPassed,validationPassed = _props$validationPass === void 0 ? true : _props$validationPass;

  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    !validationPassed && value !== '' && /*#__PURE__*/
    React.createElement("p", { className: classes.validationBlock }, /*#__PURE__*/
    React.createElement(WarningFilled, {
      color: colors.red[500],
      height: "1.2rem",
      className: classes.validationIcon }), /*#__PURE__*/

    React.createElement("span", { className: classes.validationMessage }, validationMessage)),


    !validationPassed && value === '' && /*#__PURE__*/
    React.createElement("p", { className: classes.requiredBlock }, /*#__PURE__*/
    React.createElement(WarningFilled, {
      color: colors.blue[600],
      height: "1.2rem",
      className: classes.validationIcon }), /*#__PURE__*/

    React.createElement("span", { className: classes.validationMessage }, "Required"))));




};

export default ValidationBlock;
//# sourceMappingURL=index.js.map